
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent/[lister]",
      function () {
        return require("private-next-pages/agent/[lister].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent/[lister]"])
      });
    }
  